import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { IModelWithPosition, sortByPosition } from '../model/icms-model-position';
import { ICmsModelResource } from '../model/icms-model.resource';
import { ICmsPage } from './icms-page';

declare module '@df/catalog/resource' {
    interface IResources {
        page: Resource<ICmsPage, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ICmsPageResource<T extends ICmsPage = ICmsPage> extends ICmsModelResource<T, number> {
    static override instance = ICmsPage;

    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;

    getAllExistingSorted() {
        return sortByPosition(this.getAllExisting() as IModelWithPosition[]);
    }
}
